<div class="ps-medium mr-small-b white-bg rounded-large elevation-level-1">
  <h2 class="font-heading-3">
    {{ 'MMB.carRentalTab.mainTitle' | finLocalization }}
  </h2>
</div>

<div class="mr-large-b">
  @if (enableHotelsMMB && partnerEligibilities$ | finMap: ThirdPartyAncillariesProvider.EXPEDIA_HOTEL | async) {
    <fin-mmb-hotels-widget
      class="block mr-xsmall-b"
      [order$]="order$"
      [placement]="ExpediaHotelOrigin.THIRD_PARTY_ANCILLARIES"
    ></fin-mmb-hotels-widget>
  }

  @if (partnerEligibilities$ | finMap: ThirdPartyAncillariesProvider.CAR_TRAWLER_RENTAL | async) {
    <fin-cartrawler-widget
      class="block mr-xsmall-b"
      [order]="order$ | async"
      [clientId]="clientId"
    ></fin-cartrawler-widget>
  }

  @if (
    (partnerEligibilities$ | finMap: ThirdPartyAncillariesProvider.CAR_TRAWLER_TRANSFER | async) &&
    (airportTransfersImage$ | async)
  ) {
    <fin-cartrawler-airport-transfers
      [order$]="order$"
      [cmsImage]="airportTransfersImage$ | async"
    ></fin-cartrawler-airport-transfers>
  }
</div>
